import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class SetHoveredCardOnTrackingView extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetHoveredCardOnTrackingView';

    public constructor(public id: string) {
        super(SetHoveredCardOnTrackingView.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SetHoveredCardOnTrackingView): void => {
    state.trackingViewState.hoveredCardId = action.id;
};
//@ts-ignore
registerReducer(SetHoveredCardOnTrackingView.ACTION_TYPE, reducer);